import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/basestyle";
import PrimaryHeader from "components/flujograma/PrimaryHeader";
import SecondaryHeader from "components/flujograma/SecondaryHeader";
import SearchHeader from "components/general/SearchHeader";
//import BreadCrumbs from "../components/BreadCrumbs";
import Footer from "components/flujograma/Footer";
const useStyles = makeStyles(styles);
export default function BaseScreen(props) {
    const { /*navBars, breadCrumbsRoutes,*/ bodyColor, primaryHeader, secondaryHeader, searchHeader } = props;
    const classes = useStyles();

    React.useEffect(() => {
        document.title = 'Flujograma de la Justicia Criminal';
    }, [window.location.href]);

    /*function handleClick(event) {
        event.preventDefault();
    }*/
    return (
        <div style={{ backgroundColor: bodyColor ? bodyColor : '#FFF'}} >
            {primaryHeader ? <PrimaryHeader /> : null}
            {secondaryHeader ? <SecondaryHeader /> : null}
            {searchHeader ? <SearchHeader /> : null}
            <div className={classes.wrapper} >
                {/* <Breadcrumbs aria-label="breadcrumb">
                    <Link color="inherit" href="/" onClick={handleClick}>
                        <Typography variant="h3">Inicio</Typography>
                    </Link>
                    <Link color="inherit" href="/instituciones" onClick={handleClick}>
                        <Typography variant="h3">Instituciones</Typography>
                    </Link>
                    <Typography variant="h3">Organismo Judicial</Typography>
                </Breadcrumbs> */}
                {/*breadCrumbsRoutes ? <BreadCrumbs routes={breadCrumbsRoutes}/> : null */}
                {props.children}
                <Footer/>
            </div>
        </div>
    )
}
